/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC, useState} from 'react'
import {useAuth} from '../../../../app/modules/auth'
import {Languages} from './Languages'
import UserProfileDialog from '../../../../app/pages/user/UserProfileDialog'
import {UserAvatar} from '../../../../app/generic-components/UserAvatar'
import {usePowerActions} from '../../../../app/hooks/usePowerActions'

const HeaderUserMenu: FC = () => {
  const {currentUser, logout} = useAuth()
  const [showProfileDialog, setShowProfileDialog] = useState(false)
  const power = usePowerActions()
  return (
    <>
      <UserProfileDialog
        open={showProfileDialog}
        onClose={() => setShowProfileDialog(false)}
        user={currentUser || null}
      />
      <div
        className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg menu-state-primary fw-bold py-4 fs-6 w-275px'
        data-kt-menu='true'
      >
      <div className='menu-item px-3'>
        <div className='menu-content d-flex align-items-center px-3'>
          <div className='symbol symbol-50px me-5'>
            <UserAvatar name={currentUser?.fullName || ""} size={50} />
          </div>

          <div className='d-flex flex-column'>
            <div className='fw-bolder d-flex align-items-center fs-5'>
              {currentUser?.fullName}
            </div>
            <div className='fw-bolder d-flex align-items-center fs-5 text-muted'>
              {currentUser?.orgName}
              <span className='badge badge-light-success fw-bolder fs-8 px-2 py-1 ms-2'>Pro</span>
            </div>
            <a href='#' className='fw-bold text-muted text-hover-primary fs-7'>
              {currentUser?.email}
            </a>
          </div>
        </div>
      </div>

      <div className='separator my-2'></div>

      <div className='menu-item px-5'>
        <a href="#" className='menu-link px-5' onClick={e => { e.preventDefault(); setShowProfileDialog(true); }}>
          My Profile
        </a>
      </div>

      <div className='menu-item px-5'>
        <a href='#' className='menu-link px-5'>
          Audit Logs
        </a>
      </div>

      <div className='separator my-2'></div>

      <Languages />

      <div className='menu-item px-5'>
        <a onClick={logout} className='menu-link px-5'>
          Sign Out
        </a>
      </div>

      <div className='separator my-2'></div>

      <div className='menu-item px-5'>
        <a
          href='#'
          className='menu-link px-5 text-warning'
          onClick={(e) => { e.preventDefault(); if (!power.busy) power.requestRestart(); }}
        >
          <i className='bi bi-arrow-clockwise fs-4 me-2 text-warning'></i>
          Restart Device
        </a>
      </div>

      <div className='menu-item px-5'>
        <a
          href='#'
          className='menu-link px-5 text-danger'
          onClick={(e) => { e.preventDefault(); if (!power.busy) power.requestShutdown(); }}
        >
          <i className='bi bi-power fs-4 me-2 text-danger'></i>
          Shutdown Device
        </a>
      </div>
    </div>
    {power.dialogs}
    </>
  )
}

export {HeaderUserMenu}
